import React from 'react';
import { APIProvider, Map, AdvancedMarker, Pin } from '@vis.gl/react-google-maps';

interface Poi {
  lat: number;
  lng: number;
  key: string;
  type: 'camera' | 'incident',
  location: {
    lat: number;
    lng: number;
  }
  color: string;
  camera_id: number;
}

interface PreviewMapProps {
  pois: Poi[];
  disabledPois: Poi[];
  onPoiClick: (cameraId: number) => void;
}

export function PreviewMap(props: any) {
  const { lat, lng, pois, disabledPois, onPoiClick } = props;
  if (!lat || !lng) {
    return <></>;
  }

  const center = {
    lat,
    lng,
  }
  const [map, setMap] = React.useState(null)

  const onLoad = React.useCallback(function callback(map) {
    // This is just an example of getting and using the map instance!!! don't just blindly copy!
    const bounds = new window.google.maps.LatLngBounds(center)
    map.fitBounds(bounds)

    setMap(map)
  }, [])

  const onUnmount = React.useCallback(function callback(map) {
    setMap(null)
  }, [])

  if(!center) {
    return;
  }

  return (
      <APIProvider apiKey={'AIzaSyDWpzarAcasoeZv_B-m8Tu_-CtqcA42QaE'}>
        <Map defaultCenter={center} defaultZoom={14} scaleControl={true} mapId="MINI_MAP" clickableIcons={false}>
          <AdvancedMarker position={center} title='Incident Location'>
            <Pin background={'#50DC58'} glyphColor={'#000'} borderColor={'#000'} />
          </AdvancedMarker>
          {disabledPois.map((disabledPoi: Poi) => (
              <AdvancedMarker
                  key={disabledPoi.key}
                  position={disabledPoi.location}
                  onClick={() => onPoiClick(disabledPoi.camera_id)}>
                <div>
                  <img height={35} width={35} src={(disabledPoi.color === 'blue' ? '/content/img/rp-icon-camera-sm-blue.png' : '/content/img/rp-icon-camera-inactive-sm.png')} alt="Disabled" className="me-2" />
                </div>
              </AdvancedMarker>
          ))}
          {pois.map((poi: Poi) => (
            <AdvancedMarker
              key={poi.key}
              position={poi.location}
              onClick={() => onPoiClick(poi.camera_id)}>
              <div>
                <img height={35} width={35} src={(poi.color === 'blue' ? '/content/img/rp-icon-camera-sm-blue.png' : '/content/img/rp-icon-camera-sm.png')} alt="Online" className="me-2" />
              </div>                
            </AdvancedMarker>
          ))}
        </Map>
      </APIProvider>
  );
}

export default React.memo(PreviewMap)